<template>
  <div
    class="class"
    v-if="isshow || isShow"
    @touchmove.prevent
    @mousewheel.prevent
    @click="close"
  >
    <div class="classInfo">
      <div class="class-item">
        <p class="jy-title">就业培训班</p>
        <div
          class="singleClass"
          v-for="(item, index) in jylist"
          :key="index"
          @click="getClassId(item.id, item.name, item.type)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="class-item">
        <p class="jy-title">测试进阶班</p>
        <div
          class="singleClass"
          v-for="(item, index) in cslist"
          :key="index"
          @click="getClassId(item.id, item.name)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="class-item">
        <p class="jy-title">企业服务</p>
        <div
          class="singleClass"
          v-for="(item, index) in qylist"
          :key="index"
          @click="getClassId(item.id, item.name)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="class-item">
        <p class="jy-title">认证考试</p>
        <div
          class="singleClass"
          v-for="(item, index) in xllist"
          :key="index"
          @click="getClassId(item.id, item.name)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="class-item">
        <p class="jy-title">自学资料</p>
        <router-link to="/selflearning.html"
          ><div class="singleClass">自学资料</div></router-link
        >
        <!-- <router-link to="/studycenter.html"><div class="singleClass" >干货文章</div></router-link> -->
      </div>
    </div>

    <!-- <ClassPage v-if="ID" :ID="ID" /> -->
  </div>
</template>

<script>
export default {
  props: ["isShow"],
  data() {
    return {
      // className: [
      //   { name: "全日制面授班", id: "csjy.html", type: 1 },
      //   { name: "速成就业班", id: "csjy.html", type: 2 },
      //   { name: "业余就业班", id: "csjy.html", type: 3 },
      //   { name: "测试开发班", id: "cskf.html", type: 4 },
      //   { name: "Python测试开发", id: "cskf.html", type: 5 },
      //   { name: "周末精品班", id: "zhoumo.html", type: 6 },
      //   { name: "企业内训", id: "neixun.html", type: 7 },
      //   { name: "委培直招", id: "weipei.html", type: 8 },
      //   { name: "名校专升本", id: "xueli.html", type: 9 },
      //   { name: "ISTQB认证", id: "renzheng.html", type: 10 },
      //   { name: "自学资料", id: "xueli.html", type: 11 },
      // ],
      jylist: [
        { name: "全日制面授班", id: "csjy.html" },
        { name: "测试全程班", id: "csjy.html" },
        //{ name: "测试提速班", id: "csjy.html" },
        { name: "测试定制班", id: "csjy.html" },
      ],
      cslist: [
        { name: "测试开发班", id: "cskf.html" },
        { name: "车载测试", id: "mcar.html" },
        //{ name: "Python测试开发", id: "python.html" },
        //{ name: "周末精品班", id: "zhoumo.html" },
      ],
      qylist: [
        { name: "企业内训", id: "neixun.html" },
        { name: "入职企业", id: "weipei.html" },
      ],
      xllist: [
        //{ name: "名校专升本", id: "xueli.html" },
        { name: "ISTQB认证", id: "renzheng.html" },
        { name: "软考", id: "ruankaom.html" },
      ],
      isshow: false,
    };
  },
  watch: {
    isShow: {
      handler() {
        this.isshow = this.isShow;
      },
      immediate: true,
    },
    classId: {
      handler() {
        this.showClass();
      },
    },
  },
  methods: {
    close() {
      if (this.isShow === true) {
        this.isshow = false;
        this.$emit("getShow", this.isshow);
      }
    },
    getClassId(id, shortName, type) {
      //window.location.href = '/'+id;
      this.classId = id;
      this.$router.push({
        path: `/${id}`,
        // query: {
        //    name: type
        // }
      });
    },
  },
};
</script>

<style scoped>
.class {
  background: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 190px;
  z-index: 2000;
}
.classInfo {
  width: 100%;
  /* height: 391px; */
  background: #ffffff;
  top: 0px;
  position: absolute;
  overflow: hidden;
  padding: 10px 10px;
  text-align: center;
  /* padding-bottom: 50px; */
}
.classInfo .singleClass {
  background: #f1f1f1;
  height: 84px;
  width: 214px;
  float: left;
  margin: 12px;
  text-align: center;
  line-height: 84px;
  font-size: 26px;
  color: #565656;
}
.class .jy-title {
  text-align: left;
  font-size: 20px;
  color: #5d5d5d;
  padding-bottom: 10px;
  padding-top: 10px;
  margin-left: 10px;
  margin-right: 50px;
  border-bottom: 1px solid #e2e2e2;
}
.class .class-item {
  width: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/header/ClassInfo.vue